import { render } from "./GlobalSearch.vue?vue&type=template&id=52364999&scoped=true&ts=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts"

import "./GlobalSearch.vue?vue&type=style&index=0&id=52364999&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52364999"]])

export default __exports__